var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.664,
    height: 19.664,
    viewBox: "0 0 19.664 19.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-close-6084527",
    transform: "translate(-111.2 -12.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9587",
    "data-name": "Path 9587",
    d: "M33.482,14.411a1.011,1.011,0,0,0-1.43,0l-8.105,8.105-8.105-8.105a1.011,1.011,0,0,0-1.43,1.43l8.105,8.105-8.105,8.105a1.011,1.011,0,0,0,1.43,1.43l8.105-8.105,8.106,8.106a1.011,1.011,0,0,0,1.43-1.43l-8.106-8.106,8.105-8.105A1.011,1.011,0,0,0,33.482,14.411Z",
    transform: "translate(97.086 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.0e821a586d568bee6c97a55b53225ac4.svg";
export { ForwardRef as ReactComponent };